/******************************************************************************
 * A popup displaying the terms and conditions summarized in a list. The popup
 * allows users to agree to the terms and select a "don't show again" box
 * that works by setting s value to the local storage 🐺
 * ****************************************************
 *  @format */

import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';
import React, {useContext} from 'react';
import {Button, Icon, ModalFooter, ModalHeader, Modal} from '@sttark/design-system';
import {Checkbox} from '@sttark/design-system';

// styles
import './terms_and_conditions.sass';

export const TermsAndConditions = ({setShowTermsAndConditions, isOpen}) => {
    const ctx = useContext(CartCheckoutContext);

    return (
        <Modal isOpen={isOpen} onClose={() => setShowTermsAndConditions(false)}>
            <ModalHeader onClose={() => setShowTermsAndConditions(false)}>
                Terms & Conditions
            </ModalHeader>
            <div className="terms-and-conditions-34gt position-relative">
                <div className="terms-and-conditions_content-holder">
                    <div>
                        <div className="terms-and-conditions-header d-flex align-items-center justify-content-start mb-4">
                            <Icon name="warning" color="#e5b200" />
                            <p className="font-body-md ms-3">
                                Our terms and conditions have been updated. Please review and agree.
                            </p>
                        </div>

                        {/* shipping */}
                        <div className="terms-and-conditions-list mb-4">
                            <h5 className="font-title-sm my-0">About shipping:</h5>
                            <ul>
                                <li>
                                    Standard processing ship dates are approximated. Expedited ship
                                    dates are guaranteed.
                                </li>
                                <li>
                                    Delays from new artwork submission and proof approval will
                                    postpone ship dates.
                                </li>
                                <li>
                                    Freight shipments require a loading dock at delivery. If a
                                    loading dock is absent, additional charges may apply, and you
                                    agree for us to immediately process the charges against the
                                    method of payment on file.
                                </li>
                            </ul>
                        </div>

                        {/* production */}
                        <div className="terms-and-conditions-list mb-4">
                            <h5 className="font-title-sm my-0">About production:</h5>
                            <ul>
                                <li>
                                    Colors produced may vary from on-screen appearance and between
                                    print runs.
                                </li>
                                <li>
                                    Shifting may occur on finished designs up to 1/16" in any
                                    direction.
                                </li>
                            </ul>
                        </div>

                        {/* Adhesion */}
                        <div className="terms-and-conditions-list mb-4">
                            <h5 className="font-title-sm my-0">About adhesion:</h5>
                            <ul>
                                <li>
                                    Label adhesion cannot be guaranteed and should be tested before
                                    placing your order.
                                </li>
                                <li>For best adhesion, we recommend that labels do not overlap.</li>
                            </ul>
                        </div>

                        {/* Refunds */}
                        <div className="terms-and-conditions-list mb-5">
                            <h5 className="font-title-sm my-0">About refunds:</h5>
                            <ul>
                                <li>Refunds on orders cannot be issued once production begins.</li>
                            </ul>
                        </div>

                        <Button
                            className="see-terms-and-conditions"
                            label="View All Terms & Conditions"
                            openUrlOnNewWindow
                            url="/terms"
                            secondary
                        />
                    </div>
                </div>
            </div>
            <ModalFooter>
                <div className="d-flex align-items-center justify-content-between">
                    <Checkbox
                        onChange={ctx.onDontShowTermsAgain}
                        checked={!ctx.showTerms}
                        label="Don’t show again"
                        value={ctx.showTerms}
                        bold={!ctx.showTerms}
                        name="agree_to_terms"
                    />
                    <div className="terms-footer_action d-flex align-items-center justify-content-end">
                        <div className="me-5">
                            <Button
                                label="Cancel"
                                onClick={() => {
                                    setShowTermsAndConditions(false);
                                    ctx.onChange({agreedToTerms: {$set: false}});
                                }}
                                secondary
                                large
                            />
                        </div>
                        <div>
                            <Button
                                label={'Agree'}
                                onClick={() => {
                                    setShowTermsAndConditions(false);
                                    ctx.onChange({agreedToTerms: {$set: true}});
                                }}
                                disabled={ctx.isSaving}
                                primary
                                large
                            />
                        </div>
                    </div>
                </div>
            </ModalFooter>
        </Modal>
    );
};
